import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { checkAccount } from '../../../actions/';
import { createStructuredSelector } from 'reselect';
import ControlHeader from '../../Basic/ControlHeader';
import {
  selectForm,
  selectAccountNo,
  selectBupaChecked,
    selectBupaVerified,
    selectBupaVerifyErrorMsg,
    selectVerifyAccountRetries,
     selectBupaVerifyRetrieErrorMsg
} from '../../../selectors/CustomerDetails';
//Components
import TextBox from '../../Basic/TextBox';
import LinkButton from '../../Basic/LinkButton';
import IdTypeforExisitngFortisBCCustomer from '../CustomerDetails/Common/IdTypeforExisitngFortisBCCustomer';
import util from '../../../lib/util';
class AccountVerify extends React.Component {
  constructor(props) {
    super(props); 
  }

 onLinkClicked = () =>  {
       const p = this.props;
    let validators = [     
      ['accountNumber', p => p.accountNumber, "FortisBC customer account ID"],          
    ];
    if (util.validate(validators, p.form, p.formError)) {
      p.onCheckAccount(p.accountNumber);
    }
   
 }
 
  render() {
    const p = this.props;
     return (
       <div>
       {p.bupaVerified ? null :

      <div>
       { p.bupaVerifyRetrieErrorMsg ?  null :
          <div>        
            <div className="col-sm-12" >
                <h4 className="text-primary">Include your account number in your online profile (optional)</h4>
            </div>
             <div className="col-sm-12" >
                <ControlHeader title="Enter your account number and click Continue to validate your account"/>
            </div>
              <div className="row">
                  <div className="col-sm-8">
                      <div className="col-sm-8">                         
                          <TextBox title="" name="accountNumber" required maxLength={12} disabled={p.bupaChecked} />
                      </div>
                      <div className="col-sm-2" >
                        <LinkButton text="Continue" onClick={this.onLinkClicked} disabled={p.bupaChecked} />
                      </div>
                  </div>
              </div>
              <div className="row">
                  <div className="col-sm-12">
                      {p.bupaChecked ? <IdTypeforExisitngFortisBCCustomer isRegister /> : null}
                  </div>
              </div>        
        </div>
       }
        <div>
            <div className="col-sm-12">
            {p.bupaVerifyRetrieErrorMsg ?
                <div className="errorMessage" dangerouslySetInnerHTML={{ __html: p.bupaVerifyRetrieErrorMsg }} /> : 
                <div>
                  {
                    p.bupaVerifyErrorMsg ?
                    <div className="errorMessage" dangerouslySetInnerHTML={{ __html: p.bupaVerifyErrorMsg }} /> : null
                  }
                </div>
            }
          </div>
        </div>
    </div>
       }
       </div>
    );
  }
}

AccountVerify.propTypes = { 
  form: PropTypes.object,
  accountNumber: PropTypes.string 

};
const mapStateToProps = createStructuredSelector({
    form:selectForm(),
    accountNumber:selectAccountNo(),
   bupaVerified: selectBupaVerified(),
   bupaChecked :selectBupaChecked(),
    bupaVerifyErrorMsg : selectBupaVerifyErrorMsg(),
    bupaVerifyRetrieErrorMsg: selectBupaVerifyRetrieErrorMsg(),
    verifyAccountRetries: selectVerifyAccountRetries(),
});

function mapDispatchToProps(dispatch) {
    return {           
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
         onCheckAccount: (e) => { dispatch(checkAccount(e)); }
    };
}
export default connect(mapStateToProps,mapDispatchToProps)(AccountVerify);

